import { useEffect, useRef } from "react";
import Popover from "../filterComponents/Popover";
import { useGlobalStateStore } from "../../stores/store";
import LazyLoad from "../LazyLoading/LazyLoad";

function MarketsItem({ name, image, title, values, inputdisabled }) {
  const store = useGlobalStateStore();
  const selectedFromStore = useGlobalStateStore(
    (state) => state.filter.markets[name] || []
  );

  const switchItems = useRef([]);
  const switchInputs = useRef([]);
  const mainCheckboxRef = useRef();
  const checkedOrder = useRef([]);

  const updateGlobalState = (updated) => {
    store.setGoals(name, updated);
  };

  const addSwitchItems = (el) => {
    if (el && !switchItems.current.includes(el)) {
      switchItems.current.push(el);
    }
  };

  const addSwitchInputs = (el) => {
    if (el && !switchInputs.current.includes(el)) {
      switchInputs.current.push(el);
    }
  };

  const handleMainCheckboxClick = () => {
    if (!mainCheckboxRef.current.checked) {
      updateGlobalState([]);
    } else {
      const defaultValues = ["0.5", "1.5", "2.5"];
      updateGlobalState(defaultValues);
    }
  };

  const handleSwitchChange = (e) => {
    const switchInput = e.currentTarget;
    const { value, checked } = switchInput;

    let updated = [...selectedFromStore];

    if (checked) {
      updated.push(value);
      if (updated.length > 3) updated = updated.slice(-3);
    } else {
      updated = updated.filter((v) => v !== value);
    }

    updateGlobalState(updated);
  };

  useEffect(() => {
    const isEnabled = selectedFromStore.length > 0;

    switchInputs.current.forEach((sw, i) => {
      if (!sw) return;
      sw.disabled = !isEnabled || inputdisabled;
      sw.checked = selectedFromStore.includes(sw.value);
      const item = switchItems.current[i];
      if (item) {
        if (sw.disabled) {
          item.classList.add("disabled-switch");
        } else {
          item.classList.remove("disabled-switch");
        }
      }
    });

    if (mainCheckboxRef.current) {
      mainCheckboxRef.current.checked = isEnabled;
    }
  }, [selectedFromStore, inputdisabled]);

  return (
    <div className="markets__item goals">
      <div className="markets-item__title-row">
        
        <LazyLoad>
          <img src={image} alt="icon" />
        </LazyLoad>
        <span>{title}</span>
        <div className="custom-checkbox">
          <input
            type="checkbox"
            name={name}
            id={name}
            ref={mainCheckboxRef}
            onClick={handleMainCheckboxClick}
            disabled={inputdisabled}
          />
          <label htmlFor={name}></label>
          <Popover />
        </div>
      </div>

      <div className="switch-items__wrap">
        {values.map((value, index) => {
          const safeValue = value.replace(".", "-");
          const switchName = `${name}-switch-${safeValue}`;
          return (
            <div
              className={`switch__item ${name}`}
              ref={addSwitchItems}
              key={index}
            >
              <label className="switch">
                <input
                  type="checkbox"
                  name={switchName}
                  value={value}
                  ref={addSwitchInputs}
                  id={`${name}-switch-${index}-${safeValue}`}
                  onChange={handleSwitchChange}
                  disabled={inputdisabled}
                />
                <span className="slider"></span>
              </label>
              <span className="switch-label">{value}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default MarketsItem;
